// src/pages/admin/AdminProductTypeForm.js
import React, { useEffect, useState } from 'react';
import { Container, Typography, Box, TextField, Button, Alert } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../services/api';

const AdminProductTypeForm = () => {
  const { id } = useParams(); // id varsa düzenleme, yoksa yeni oluşturma
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (id) {
      setIsEdit(true);
      // Mevcut ürün tipi bilgilerini çekiyoruz
      axiosInstance.get(`/producttypes/${id}`)
        .then(response => {
          setName(response.data.name);
          setDescription(response.data.description);
        })
        .catch(err => {
          console.error(err);
          setError('Ürün tipi bilgileri alınamadı.');
        });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Sadece form verilerini gönderiyoruz, id URL parametresi üzerinden alınıyor
    const data = { name, description };
    try {
      if (isEdit) {
        // PUT isteğinde sadece name ve description gönderiliyor
        await axiosInstance.put(`/producttypes/${id}`, data);
      } else {
        await axiosInstance.post(`/producttypes`, data);
      }
      navigate('/admin/producttypes');
    } catch (err) {
      console.error(err);
      setError('Bir hata oluştu.');
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" sx={{ mb: 3 }}>
          {isEdit ? 'Ürün Tipini Düzenle' : 'Yeni Ürün Tipi Ekle'}
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <form onSubmit={handleSubmit}>
          <TextField
            label="Adı"
            fullWidth
            variant="outlined"
            margin="normal"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            label="Açıklama"
            fullWidth
            variant="outlined"
            margin="normal"
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <Button 
            type="submit" 
            variant="contained" 
            color="primary" 
            fullWidth 
            sx={{ mt: 2 }}
          >
            {isEdit ? 'Güncelle' : 'Oluştur'}
          </Button>
        </form>
      </Box>
    </Container>
  );
};

export default AdminProductTypeForm;
